import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CompleteEmailVerificationResponse extends BackendResponse {}

export interface CompleteEmailVerificationParameters extends NextApiParams {
  idVerify: number;
  otc: string;
}

export const completeEmailVerification = withNextApi<
  CompleteEmailVerificationResponse,
  CompleteEmailVerificationParameters
>("/cvp/CvpCompleteEmailVerification");
